<template>
    <div class="vuetable-filterbar col-md-12">
	    <div class="form-group p-l">
            <b-container fluid class="p-a-0">
                <b-row no-gutters>
                    <b-col sm="6" md="2" class="p-a-0">
                        <div class="fl-flex-label fl-collapsed fl-background">
                            <input type="text" class="form-control" v-model="nome" @keyup.enter="doFilter">
                            <label class="fl-label" for="default-input" style="left: 13px; right: 12px;">Nome</label>
                        </div>
                    </b-col>

                    <b-col sm="6" md="2" class="p-a-0">
                        <div class="fl-flex-label fl-collapsed fl-background">
                            <input type="text" class="form-control" v-model="email" @keyup.enter="doFilter">
                            <label class="fl-label" for="default-input" style="left: 13px; right: 12px;">Email</label>
                        </div>
                    </b-col>
                    <b-col sm="6" md="2" class="p-a-0">
                        <multiselect v-model="status"
                        :options="optionsLivStatus"
                        track-by="value"
                        label="label"
                        :hide-selected="true"
                        placeholder="Status"
                        tag-placeholder="Selecionar"
                        select-label="Selecionar"
                        selected-label="Selecionado"
                        deselect-label="Remover"
                        ></multiselect>
                    </b-col>
                    <b-col sm="6" md="2" class="p-a-0">
                        <multiselect v-model="role"
                        :options="this.$parent.optionsListItemRole"
                        track-by="value"
                        label="label"
                        :hide-selected="true"
                        placeholder="Role"
                        tag-placeholder="Selecionar"
                        select-label="Selecionar"
                        selected-label="Selecionado"
                        deselect-label="Remover"
                        ></multiselect>
                    </b-col>
                    <b-col sm="6" md="2" class="p-a-0">
                        <multiselect v-model="unidade"
                        :options="optionsUnidade"
                        track-by="value"
                        label="label"
                        :hide-selected="true"
                        placeholder="Unidade"
                        tag-placeholder="Selecionar"
                        select-label="Selecionar"
                        selected-label="Selecionado"
                        deselect-label="Remover"
                        ></multiselect>
                    </b-col>

          <b-col cols="2" class="p-a-0">
                <div class="input-group-btn">
                  <div class="btn-group">
                    <button type="button" class="btn btn-secondary btn-outline" @click="doFilter">Filtrar</button>
                    <button type="button" class="btn btn-secondary btn-outline" @click="resetFilter">Limpar</button>
                  </div>
                </div>
          </b-col>
      </b-row>
    </b-container>
  </div>
</div>
</template>


<script>
import Multiselect from 'vue-multiselect'
export default {
  components: {
      Multiselect
  },
  data () {
    return {
      helpForm: new Form({params: []}),
      email: '',
      nome: '',
      unidade: [],
      role: [],
      status: [],
      optionsLivStatus: [],
      optionsUnidade: [],
      optionsRole: [],
      data_filter: []
    }
  },
  mounted() {
      this.getStatus();
      this.getUnidade();
      this.getRole();
    },
  methods: {
      doFilter () {
          this.data_filter = {email: this.email,
                              status: this.status,
                              nome: this.nome,
                              unidade: this.unidade,
                              role: this.role};
          this.$events.fire('filter-set', this.data_filter);
      },
      resetFilter () {
        this.email = '';  // clear the text in text input
        this.nome = '';
        this.status = '';
        this.unidade = '';
        this.role = '';
        this.$events.fire('filter-reset');
      },
      getStatus() {
          this.helpForm.params = { tabela: 'usuario',
                                  coluna: 'status' };

          this.helpForm.get('/api/listitemvalor/jsonlist').then(response =>
          {
              new ReturnApi(response, this, true, false, false);
              response.items.forEach((obj)=>
              {
                  this.optionsLivStatus.push({ label: obj.descr, value: obj.valor })
              });
          })
          .catch(errors =>
          {
              new ReturnApi(errors, this, true, false, false)
          });
      },
      getUnidade() {
          this.helpForm.get('/api/unidade/jsonlist').then(response =>
          {
              new ReturnApi(response, this, true, false, false);
              response.items.forEach((obj)=>
              {
                  this.optionsUnidade.push({ label: obj.cd+" - "+obj.descr, value: obj.unidade_id })
              })
          })
          .catch(errors =>
          {
              new ReturnApi(errors, this)
          });
      },
      getRole() {
          this.helpForm.get('/api/role/jsonlist').then(response =>
          {
              new ReturnApi(response, this, true, false, false);
              response.items.forEach((obj)=>
              {
                  this.optionsRole.push({ label: obj.cd+" - "+obj.descr, value: obj.id })
              })
          })
          .catch(errors =>
          {
              new ReturnApi(errors, this)
          });
      },
  },
  computed: {
    vuetableFilterButton: {
      get () {
        return this.$store.state.vuetable.filterButton;
      },
     },
    }
}
</script>
